import { SxProps, Tooltip } from '@mui/material';
import React, { ReactElement, useState } from 'react';
import I18n from '../../i18n/I18n';
import { useStyling } from '../../Theme';

type CopyToClipboardProps = {
    clipboardContent: string;
    hoverTitle?: string | ReactElement;
    clickTitle?: string | ReactElement;
    renderCustomComponent: (props: any) => ReactElement;
    sx?: SxProps;
};

export default (props: CopyToClipboardProps) => {
    const {
        clipboardContent,
        hoverTitle = <I18n token="form.tooltip.copy" />,
        clickTitle = <I18n token="form.tooltip.copied" />,
        renderCustomComponent,
        sx
    } = props;
    const { theme } = useStyling();

    const [tooltipTitle, setTooltipTitle] = useState<string | ReactElement>(hoverTitle);
    const [showTooltip, setShowTooltip] = useState<boolean>(false);

    const copyToClipboard = (e: React.ChangeEvent<HTMLInputElement>) => {
        e.stopPropagation();
        navigator.clipboard
            .writeText(clipboardContent)
            .then(() => handleShowTooltipOnClick(clickTitle))
            .catch(() => setTooltipTitle('copy.to.clipboard.failure'));
    };

    const handleShowTooltipOnClick = (title: string | ReactElement) => {
        setTooltipTitle(title);
        setShowTooltip(true);
        setTimeout(() => {
            setShowTooltip(false);
        }, 1000);
    };

    return (
        <Tooltip
            open={showTooltip}
            onOpen={() => {
                setShowTooltip(true);
                setTooltipTitle(hoverTitle);
            }}
            onClose={() => {
                setShowTooltip(false);
            }}
            title={tooltipTitle}
        >
            {renderCustomComponent({
                sx: {
                    color: `${theme.palette.text.secondary}`,
                    width: '20px',
                    height: '20px',
                    cursor: 'pointer',
                    ...sx
                },
                onClick: copyToClipboard
            })}
        </Tooltip>
    );
};
